const FoilerBadge = ({ foiled }: { foiled: boolean }) =>
  foiled ? (
    <div
      className={`rounded-full flex items-center justify-center border-px h-7 w-14
  from-[#98F2FF] via-[#FF99CD] to-[#F7F8D6] bg-gradient-to-tl border-white`}
    >
      <i className="fa-solid fa-sparkles text-white" />
    </div>
  ) : (
    <div
      className={`rounded-full flex items-center justify-center border-px h-7 w-14
    from-[#434343] via-[#767676] to-[#434343] bg-gradient-to-tl border-white`}
    >
      <i className="fa-solid fa-lock text-white" />
    </div>
  );
export default FoilerBadge;
